var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"home"},[_c('van-nav-bar',{attrs:{"title":"求职管理","fixed":"","placeholder":"","z-index":"10"}}),_c('Job')],1)}
var staticRenderFns = []

export { render, staticRenderFns }